import script from "./commonHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonHeader.vue?vue&type=script&setup=true&lang=ts"

import "./commonHeader.vue?vue&type=style&index=0&id=1fd609e5&lang=scss"
import "./commonHeader.vue?vue&type=style&index=1&id=1fd609e5&lang=css"

const __exports__ = script;

export default __exports__